var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.586 246.605C294.445 224.363 304 197.342 304 168C304 93 243 32 168 32H152C77 32 16 93 16 168C16 197.342 25.555 224.363 41.414 246.605C15.955 271.334 0 305.783 0 344C0 419 61 480 136 480H184C259 480 320 419 320 344C320 305.783 304.045 271.334 278.586 246.605ZM152 128H168C190.062 128 208 145.938 208 168S190.062 208 168 208H152C129.938 208 112 190.062 112 168S129.938 128 152 128ZM184 384H136C113.938 384 96 366.062 96 344S113.938 304 136 304H184C206.062 304 224 321.938 224 344S206.062 384 184 384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.bae26e51e1621bf9c78dbf211ae7e22e.svg";
export { ForwardRef as ReactComponent };